import { ProjectSetting } from '@src/core';
import { ProjectDemoForms } from './project-demo-forms';
import { ProjectPearlsFase1 } from './project-pearls-fase1';
import { ProjectPearlsFase2 } from './project-pearls-fase2';
import { ProjectPearlsTeste } from './project-pearls-teste';

const ProjectSettings: Record<string, ProjectSetting> = {
  'project-pearls-fase1': ProjectPearlsFase1,
  'project-pearls-fase2': ProjectPearlsFase2,
  'project-pearls-teste': ProjectPearlsTeste,
  'project-demo-forms': ProjectDemoForms,
};

export { ProjectSettings };
